import React from "react";
import { Button, Space } from "antd";
import { useSelector } from "react-redux";
import {
  CheckOutlined,
  DeleteOutlined,
  CloseOutlined,
  UnlockOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { useIntl } from "react-intl";
import RestrictedComponent from "../util/RestrictedComponent";
import { usePermission } from "../../hooks/accessControl";

const SelectionActions = (props) => {
  const {
    selectedRowKeys,
    onSaveChanges,
    onApproveSelected,
    onDeleteSelected,
    onUnlockSelected,
    onTransferSelected,
    branchId,
    items,
  } = props;

  const intl = useIntl();
  const saveChangesLoading = useSelector(
    (state) => state.pendingActions["scheduling/edit"]
  );
  const approveLoading = useSelector(
    (state) => state.pendingActions["scheduling/approveSchedulingEvent"]
  );

  const unlockLoading = useSelector(
    (state) => state.pendingActions["scheduling/unlock_events"]
  );

  const deleteLoading = useSelector(
    (state) => state.pendingActions["scheduling/delete_events"]
  );

  const hasUnlockEventPermission = usePermission(
    branchId,
    "patients",
    "unlock_event"
  );

  let hasProspectusEvent = selectedRowKeys.some((id) =>
    items.some((item) => item.id === id && item.prospectus_id)
  );

  let hasApprovedEvent = selectedRowKeys.some((id) =>
    items.some((item) => item.id === id && item.approved)
  );

  return (
    <RestrictedComponent resource={"patients"} action={"editor"} comp={null}>
      <div style={{ padding: "10px 20px", height: "50px" }}>
        {selectedRowKeys && selectedRowKeys.length > 0 ? (
          <Space>
            {!hasProspectusEvent && (
              <Button
                onClick={() => onApproveSelected(true)}
                loading={approveLoading}
                icon={<CheckOutlined />}
              >
                {" " +
                  intl.formatMessage({
                    id: "app.actions.approve",
                  })}
              </Button>
            )}
            {!hasProspectusEvent && (
              <Button
                onClick={() => onApproveSelected(false)}
                loading={approveLoading}
                icon={<CloseOutlined />}
              >
                {" " +
                  intl.formatMessage({
                    id: "app.actions.unapprove",
                  })}
              </Button>
            )}
            {!hasApprovedEvent && (
              <Button
                onClick={() => onTransferSelected(false)}
                loading={approveLoading}
                icon={<SwapOutlined />}
              >
                {" " +
                  intl.formatMessage({
                    id: "app.actions.transfer_events",
                  })}
              </Button>
            )}

            {hasUnlockEventPermission && hasProspectusEvent && (
              <Button
                onClick={() => onUnlockSelected()}
                loading={unlockLoading}
                icon={<UnlockOutlined />}
              >
                {" " +
                  intl.formatMessage({
                    id: "app.actions.unlock_event",
                  })}
              </Button>
            )}
            {!hasProspectusEvent && (
              <Button
                type="danger"
                onClick={onDeleteSelected}
                loading={deleteLoading}
                icon={<DeleteOutlined />}
              >
                {" " +
                  intl.formatMessage({
                    id: "app.actions.deletion",
                  })}
              </Button>
            )}
          </Space>
        ) : (
          <Button
            className="floatingBtn"
            loading={saveChangesLoading}
            // disabled={disabled}
            onClick={() => onSaveChanges()}
            type="primary"
            icon={<CheckOutlined />}
          >
            {" " +
              intl.formatMessage({
                id: "app.actions.saveChanges",
              })}
          </Button>
        )}
      </div>
    </RestrictedComponent>
  );
};

export default SelectionActions;
